import { createRequestHelper } from '@utils/swr'
import { type ProductSubshipVariationSettingRequest } from '../types/apiRequest'
import { type ProductSubshipVariationSettingResponse } from '../types/apiResponse'
import { type WpApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<WpApis['get']['productSubshipVariationSetting'], ProductSubshipVariationSettingResponse, ProductSubshipVariationSettingRequest>({
  client: 'wpRelay',
  key: (params) => {
    const { parent_product_id, product_id } = params || {}
    if (!parent_product_id || !product_id) return null
    return `/wp-json/lds/public/subship-setting-variation?parent_product_id=${parent_product_id}&product_id=${product_id}`
  },
})

export const useApiProductSubshipVariationSetting = useRequest
